"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _tools = require("./utils/tools");

var _action = require("./action");

var _excluded = ["href", "label", "value", "target"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// 兼容pc 渲染问题 \\"

/* eslint-disable no-useless-escape */
var REG_TPL = /<(?=[div|p|span|strong|link|file|tel|modal|copy])([\s\S]+?)>([\s\S]*?)<\/([\\"\w]+?)>/g;
var REG_TAG = /([a-zA-z]+)\s*(.*)/;
var REG_VALUE = /{{(.*?)}}/g; // const REG_JS = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g;

var REG_JS = /^(.*)?(\|\|)(.*)?/g;
var REG_BR = /([\s\S]*?)(<br[\s\/]*>|\\n)/gi; // 标签保留字段

var tagReserved = ['p', 'span', 'strong', 'link', 'tel', 'file', 'modal', 'copy']; // 属性保留字段

var attrReserved = ['href', 'style', 'className', 'target', 'label', 'value'];
/**
 * 转义字符串
 * @param {string} text 内容
 */

var stringifyHTML = function stringifyHTML(text) {
  return text.replace(/\r?\n/g, '\\n');
};
/**
 * 解析属性
 * @param text 文本
 */


var parseAttr = function parseAttr(text) {
  if (!text) {
    return {};
  }

  var attrs = {};
  text // style={"color": "red"}
  .replace(/([a-zA-z]+)=({.+?})/g, function (_and, attr, value) {
    if (attr && attrReserved.indexOf(attr) > -1 && value) {
      // style={'color': 'red'} 替换 style={"color": "red"}

      /* eslint-disable no-useless-escape */
      value = value.replace(/\'/g, '\"');
      attrs[attr] = JSON.parse(value);
    }
  }) // href="https://iyunbao.com"
  .replace(/([a-zA-z]+)=["'](.*?)["']/g, function (_and, attr, value) {
    if (attr && attrReserved.indexOf(attr) > -1) {
      attrs[attr] = value;
    }
  });
  return attrs;
};
/**
 * 换行 <br /> | \r\n
 * @param {string} tpl  模块
 * return any[]
 */


var lineBreak = function lineBreak(tpl) {
  if (tpl && (tpl.match(REG_BR) || []).length) {
    var parseDOM = [];
    var placeIndex = 0;
    tpl.replace(REG_BR, function (and, start, _tag, index) {
      var _id = (0, _tools.uuid)();

      if (start !== '') {
        parseDOM.push(start);
      }

      parseDOM.push( /*#__PURE__*/_react.default.createElement("br", {
        key: _id
      }));
      placeIndex = index + and.length;
    }); // 不齐尾部文字

    if (placeIndex < tpl.length) {
      parseDOM.push(tpl.slice(placeIndex, tpl.length));
    }

    return parseDOM;
  }

  return tpl;
};
/**
 * 渲染标签
 * @param text  文字
 * @param startTag   标签内容
 */


var renderTag = function renderTag(text, startTag) {
  var parseTag = null;

  if (!startTag) {
    return text;
  } // 字符串转义


  startTag = stringifyHTML(startTag);
  startTag.replace(REG_TAG, function (_and, tag, attr) {
    if (tagReserved.indexOf(tag) > -1) {
      var _id = (0, _tools.uuid)();

      var attrs = parseAttr(attr);

      var href = attrs.href,
          label = attrs.label,
          value = attrs.value,
          target = attrs.target,
          others = _objectWithoutProperties(attrs, _excluded);

      switch (tag) {
        // 换行
        case 'p':
          parseTag = /*#__PURE__*/_react.default.createElement("p", _extends({
            key: _id
          }, others), text);
          break;
        // 行元素

        case 'span':
          parseTag = /*#__PURE__*/_react.default.createElement("span", _extends({
            key: _id
          }, others), text);
          break;
        // 链接，文件

        case 'link':
        case 'file':
          // app内 ios A标签属性有target="_blank"，打不开兼容
          if (target && !(_tools.isInApp && _tools.isIOS)) {
            others.target = target;
          }

          parseTag = /*#__PURE__*/_react.default.createElement("a", _extends({
            key: _id,
            href: href
          }, others), text);
          break;
        // 链接，文件

        case 'tel':
          parseTag = /*#__PURE__*/_react.default.createElement("a", _extends({
            key: _id,
            href: "tel: ".concat(href)
          }, others), text);
          break;
        // 加粗

        case 'strong':
          parseTag = /*#__PURE__*/_react.default.createElement("strong", _extends({
            key: _id
          }, others), text);
          break;
        // 提示层

        case 'modal':
          // eslint-disable-next-line
          parseTag = /*#__PURE__*/_react.default.createElement("a", _extends({
            key: _id,
            href: "javascript:",
            onClick: function onClick() {
              return (0, _action.tips)({
                content: lineBreak(value),
                label: label
              }, {});
            }
          }, others), text || label);
          break;
        // 提示层

        case 'copy':
          // eslint-disable-next-line
          parseTag = /*#__PURE__*/_react.default.createElement("a", _extends({
            key: _id,
            href: "javascript:",
            onClick: function onClick() {
              return (0, _action.copy)({
                text: value
              });
            }
          }, others), text || label);
          break;

        default:
          break;
      }
    }
  });
  return parseTag;
};
/**
 * 作用域值
 * 对象错误，语法错误直接报错xx.0.xx 替换xx[0].xx
 * @param {string} key 值
 * return string
 */


var scopeValue = function scopeValue(key) {
  if (!key) {
    return '';
  }

  key = "__".concat(key);
  return key.replace(/\.(\d+)/g, '[$1]');
};
/**
 * 作用域数据
 * @param {any} data 数据
 * return any
 */


var scopeData = function scopeData(data) {
  if (data && (0, _tools.isObject)(data)) {
    Object.keys(data).forEach(function (key) {
      if (!(/^__.*/.test(key) && data[key] !== data["__".concat(key)])) {
        data["__".concat(key)] = data[key];
      }
    });
    return data;
  }

  return data || {};
};
/**
 * 编译
 * @param {string} tpl  文本
 * @param {object} data 数据
 */


var compile = function compile(tpl, data) {
  if (!tpl) {
    return tpl;
  }

  var match;
  var code = 'var __code__ = [];\nwith (__data__) {\n';
  var placeIndex = 0; // 解析html

  function parseHTML(line) {
    line = line.replace(/('|")/g, '\\$1').replace(/\n/g, ' ').replace(/(^\s+)|(\s+$)/g, '');

    if (line) {
      code += "__code__.push(\"".concat(line, "\");\n");
    }
  } // 解析JS代码


  function parseJS(line) {
    line = line.replace(/(^\s+)|(\s+$)/g, '');

    if (line) {
      // code += (line.match(REG_JS) ? `${line}\n` : `__code__.push(${line});\n`);
      // name || 'ss'
      if (line.match(REG_JS)) {
        line.replace(REG_JS, function (_and, value, _handlers, defaultValue) {
          code += 'try {\n';
          code += "if (typeof ".concat(scopeValue(value), " !== 'undefined') {\n");
          code += "__code__.push(".concat(scopeValue(value), " || ").concat(defaultValue, ");\n");
          code += "} else if (typeof ".concat(defaultValue, " !== 'undefined') {\n");
          code += "__code__.push(".concat(defaultValue, ");\n");
          code += '}\n} catch(error) {\n';
          code += "__code__.push(typeof ".concat(defaultValue, " !== 'undefined' ? ").concat(defaultValue, " : '');\nconsole.error(error);\n};\n");
        });
      } else {
        code += "__code__.push(typeof ".concat(scopeValue(line), " !== 'undefined' ? ").concat(scopeValue(line), " : '');\n");
      }
    }
  }
  /* eslint-disable-next-line */


  while (match = REG_VALUE.exec(tpl)) {
    parseHTML(tpl.slice(placeIndex, match.index));
    parseJS(match[1]);
    placeIndex = match.index + match[0].length;
  } // 补全尾部


  if (placeIndex < tpl.length) {
    parseHTML(tpl.substr(placeIndex));
  }

  code += '};\n return __code__.join("");';
  /* eslint-disable-next-line */

  return new Function('__data__', code.replace(/[\r\t\n]/g, ''))(scopeData(data));
};
/**
 * 模板渲染
 * @param tpl   文字
 * @param _data 数据
 */


var template = function template(tpl, data) {
  if (!tpl) {
    return '';
  }

  var parseDOM = [];
  var placeIndex = 0; // 替换value

  if ((tpl.match(REG_VALUE) || []).length) {
    try {
      tpl = compile(tpl, data);
    } catch (error) {
      console.error('template compile error', error);
    }
  }

  try {
    if (REG_TPL.test(tpl)) {
      tpl.replace(REG_TPL, function (and, startTag, text, endTag, index) {
        var extractStart = tpl.slice(placeIndex, index);
        var startTpl = extractStart || null; // 匹配开头文字

        if (startTpl) {
          parseDOM.push(lineBreak(startTpl));
        } // 标签渲染，包含文字


        if (startTag) {
          // 头尾标签必须相同
          if (startTag.indexOf(endTag) > -1) {
            parseDOM.push(renderTag(text, startTag));
          } else if (text) {
            parseDOM.push(text);
          }
        }

        placeIndex = index + and.length;
      }); // 不齐尾部文字

      if (placeIndex < tpl.length) {
        var parseText = tpl.slice(placeIndex, tpl.length);
        parseDOM.push(lineBreak(parseText));
      }

      return /*#__PURE__*/_react.default.createElement("span", null, parseDOM); // 文字无解析标签
    }

    if ((tpl.match(REG_BR) || []).length) {
      return /*#__PURE__*/_react.default.createElement("span", null, lineBreak(tpl));
    }
  } catch (error) {
    console.error('parse template error', error);
  }

  return tpl;
};

var _default = template;
exports.default = _default;